import { ReactNode, useState } from "react";
import { SnackbarProvider } from "notistack";
import { SnackbarsCustomStyle, AUTO_HIDE_DURATION, MAX_SNACK } from "@Layouts/components/Snackbars";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import DoneIcon from "@mui/icons-material/Done";
import Layer from "@/Washouts/views/Layers/WashoutReview/Layer";
import GetPeriodTitle from "@/Washouts/components/GetPeriodTitle";
import { ICommissionCycle, IPayPeriod } from "@/Common/api/types/CommissionCycle";
import { useCommissionCyclesData } from "@/Washouts/hooks/common/useCommissionCyclesData";

export default function WashoutReview() {
	const [cycleTitle, setCycleTitle] = useState<ReactNode>("");
	const { partnerPayPeriod } = useCommissionCyclesData();

	const setTitle = (_cycle?: ICommissionCycle, payPeriod?: IPayPeriod) => {
		setCycleTitle(GetPeriodTitle({ payPeriod, partnerPayPeriod, startLabel: "Washout Review" }));
	};

	return (
		<SnackbarProvider
			maxSnack={MAX_SNACK}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			autoHideDuration={AUTO_HIDE_DURATION}
			iconVariant={{ 
				error: <ErrorOutlineRoundedIcon fontSize="small" className="mr-2" />,
				success: <DoneIcon fontSize="small" className="mr-2" /> 
			}}
			Components={{
				error: SnackbarsCustomStyle,
				success: SnackbarsCustomStyle
			}}
		>
			<Layer title={cycleTitle} onUpdateTitle={setTitle} />
		</SnackbarProvider>
	);
}
